<template>
    <div>
        <el-form
            ref="form"
            :inline="true"
            :model="query"
            class="query-form filter-block"
            size="mini"
        >
            <el-form-item label="" class="query-form-item">
                <el-button type="primary" icon="el-icon-back" @click="goBackList"></el-button>
            </el-form-item>
            <el-form-item label="asin:" class="query-form-item">
                <el-input
                    v-model="query.asin"
                    placeholder="请输入asin"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item label="排序:" class="query-form-item">
                <el-select v-model="query.lowest_price_priority_order" placeholder="请选择">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="主Asin:" class="query-form-item">
                <el-select v-model="query.is_main" placeholder="请选择">
                    <el-option
                        v-for="item in isMainArr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button icon="el-icon-search" type="primary" @click="onSubmit">查询</el-button>
                <!--                <el-button @click="download_file" type="primary" size="mini">ratings|reviews变化趋势</el-button>-->
                <!--                <el-button @click="download_file" type="primary" size="mini">导出数据</el-button>-->
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            size="mini"
            @row-click="clickRowHandle"
            @selection-change="handleSelectionChange"
            ref="multipleTable"
            border
            height='calc(100vh - 190px)'
            style="width: 100%;">
            <!--            <el-table-column-->
            <!--                type="selection"-->
            <!--                width="40"-->
            <!--                align="center">-->
            <!--            </el-table-column>-->
            <el-table-column
                label="id"
                width="80"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>

            <el-table-column label="图片" width="95" align="center">
                <template slot-scope="scope">
                    <el-popover placement="right" title>
                        <div
                            style="width: 77px;height: 77px;"
                            slot="reference"
                        >
                            <img
                                style="width:100%;height:100%;"
                                :src="scope.row.image_url"
                            />
                        </div>
                    </el-popover>
                </template>
            </el-table-column>

            <el-table-column label="设主Asin" width="100" align="center">
                <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.is_main == 1" @change="changeIsMain(scope.row)"/>
                </template>
            </el-table-column>

            <el-table-column label="子ASIN" width="150" align="center">
                <template slot-scope="scope">
                    <el-tooltip effect="dark" :content="scope.row.created_time" placement="top-start">
                        <div>
                            <span>{{ scope.row.asin }}</span>
                            <!--                            <icon-svg-->
                            <!--                                :icon-class="scope.row.state"-->
                            <!--                                style="font-size: 24px;margin-left:5px;"-->
                            <!--                            ></icon-svg>-->
                            <div v-if="scope.row.asin != null" @click.stop="edirectToAsin(scope.row)"
                                 style="cursor: pointer;color: rgb(52, 73, 94);">
                                <i class="el-icon-s-promotion" style="margin-right:5px;"></i>{{ scope.row.asin }}
                            </div>
                        </div>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="标题" min-width="200" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.title }}</div>
                </template>
            </el-table-column>
            <el-table-column label="当前价格" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.local_price }}</div>
                </template>
            </el-table-column>
            <el-table-column label="标签价" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.list_price }}</div>
                </template>
            </el-table-column>
            <el-table-column label="折扣率" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.discount_rate }}</div>
                </template>
            </el-table-column>

            <el-table-column label="Coupon" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.coupon_rate }}</div>
                </template>
            </el-table-column>

            <el-table-column label="是否最低价" width="100" align="center">
                <template slot-scope="scope">
                    <div>
                        <div v-if="scope.row.is_lowest_price == 1">
                            <span style="color: red;font-weight:900">是 </span>
                        </div>
                        <div v-else>
                            否
                        </div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="卖家" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.sold_shop_name }}</div>
                </template>
            </el-table-column>
            <el-table-column label="Ptd" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.ptd }}</div>
                </template>
            </el-table-column>
            <el-table-column label="Deal标签" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.deal }}</div>
                </template>
            </el-table-column>
            <el-table-column label="排名" width="120" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight fixedUl">{{ scope.row.rank }}</div>
                </template>
            </el-table-column>

            <el-table-column label="五点描述" min-width="200" align="center">
                <template slot-scope="scope">
                    <ul v-if="scope.row.five_point && Array.isArray(scope.row.five_point)">
                        <li v-for="item in scope.row.five_point" class="fivePointItem">{{item}}</li>
                    </ul>
                </template>
            </el-table-column>
            <el-table-column label="爬取时间" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.created_time }}</div>
                </template>
            </el-table-column>
            <el-table-column label="昨日变化" width="560" align="center">
                <template slot-scope="scope">
                    <div v-show="scope.row.change && !Array.isArray(scope.row.change)">

                        <div>
                            <div class="ceil-span-title" style="height: 1px"></div>
                            <div class="ceil-span">总</div>
                            <div class="ceil-span">一星</div>
                            <div class="ceil-span">二星</div>
                            <div class="ceil-span">三星</div>
                            <div class="ceil-span">四星</div>
                            <div class="ceil-span">五星</div>
                        </div>
                        <br/>

                        <div>
                            <div class="ceil-span-title">ratings:</div>
                            <template v-for="item in starArr">
                                <div class="ceil-span">{{ scope.row.change[`rating_${item}`] }}&nbsp;
                                    <span class="ceil-span-change ceil-color_green"
                                          v-if="scope.row.change[`rating_${item}_change`] >= 0">( {{
                                            scope.row.change[`rating_${item}_change`]
                                        }}<i
                                            class="el-icon-top"></i> )</span>
                                    <span class="ceil-span-change ceil-color_red"
                                          v-else-if="scope.row.change[`rating_${item}_change`] < 0">( {{
                                            scope.row.change[`rating_${item}_change`]
                                        }}<i class="el-icon-bottom"></i> )</span>
                                    <span class="ceil-span-change" v-else style="height: 1px"></span>
                                </div>
                            </template>
                        </div>
                        <br/>

                        <div>
                            <div class="ceil-span-title">reviews:</div>
                            <template v-for="item in starArr">
                                <div class="ceil-span">{{ scope.row.change[`review_${item}`] }}&nbsp;
                                    <span class="ceil-span-change ceil-color_green"
                                          v-if="scope.row.change[`review_${item}_change`] >= 0">( {{
                                            scope.row.change[`review_${item}_change`]
                                        }}<i
                                            class="el-icon-top"></i> )</span>
                                    <span class="ceil-span-change ceil-color_red"
                                          v-else-if="scope.row.change[`review_${item}_change`] < 0">( {{
                                            scope.row.change[`review_${item}_change`]
                                        }}<i class="el-icon-bottom"></i> )</span>
                                    <span class="ceil-span-change" v-else style="height: 1px"></span></div>
                            </template>
                        </div>
                        <br/>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="200" align="center" fixed="right">
                <template slot-scope="scope">
                    <div @click.stop>
                        <el-button
                            style="margin: 5px 0 5px 10px"
                            type="primary"
                            size="mini"
                            @click.native="downFile(scope.row)"
                        >导出
                        </el-button>
                        <!--                        <el-button-->
                        <!--                            style="margin: 5px 0 5px 10px"-->
                        <!--                            type="primary"-->
                        <!--                            size="mini"-->
                        <!--                            @click.native="deleteItem(scope.row)"-->
                        <!--                        >删除-->
                        <!--                        </el-button>-->
                        <el-button
                            style="margin: 5px 0 5px 10px"
                            type="success"
                            size="mini"
                            @click.native="seeChange(scope.row)"
                        >评价趋势
                        </el-button>
                        <el-button
                            style="margin: 5px 0 5px 10px"
                            type="primary"
                            size="mini"
                            @click.native="priceChange(scope.row)"
                        >价格趋势
                        </el-button>
                        <el-button
                            style="margin: 5px 0 5px 10px"
                            type="primary"
                            size="mini"
                            @click.native="evaluate(scope.row)"
                        >评价记录
                        </el-button>
                        <el-button
                            style="margin: 5px 0 5px 10px"
                            type="primary"
                            size="mini"
                            v-if="showUpdatePriceBtn"
                            :loading="scope.row.loading"
                            @click.native="pluginUpdatePrice(scope.row, scope.$index)"
                        >插件更新价格
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="query.page"
            :page-size="query.limit"
            :page-sizes="[10, 20, 50]"
            :total="total"
            background
            style="float: right;margin-top: 10px; margin-bottom: 5px"
            layout="total, sizes, prev, pager, next">
        </el-pagination>
        <import-data ref="importDataModal" @close-callback="closeCllback"></import-data>
        <asinChildChangeModal :visible="ctrl.asinChangeModal" :info="editInfo" @close-callback="closeCllback"/>
        <child-info-modal :visible="ctrl.childInfoVisible" :info="childInfo"
                          @close-callback="closeCllback"></child-info-modal>
        <priceChangeModal :visible="ctrl.priceChangModal" :info="editInfo" @close-callback="closeCllback"/>
        <evaluationRecord :visible="ctrl.uploadFileListVisible" :info="editInfo" @close-callback="closeCllback"/>
        <div id="update_price_response" @click="updatePriceResponse" v-show="false" ref="update_price_response"></div>
    </div>
</template>

<script>
import * as api from '@/api/Product/Product.js'
import {downloadFileUrl, binary_download} from '@/utils/method'
import importData from './importData'
import {track_asin_sub_export, track_asin_sub_index, track_asin_sub_update_is_main} from '@/api/Product/Product.js'
import asinChildChangeModal from '@/views/asinTailAfter/asinChildChangeModal.vue'
import ChildInfoModal from '@/views/asinTailAfter/childInfoModal.vue'
import priceChangeModal from '@/views/asinTailAfter/priceChangeModal.vue'
import evaluationRecord from '@/views/asinTailAfter/evaluationRecord.vue'
import {checkPlug} from '@/utils/method'
import {MessageBox} from 'element-ui'

export default {
    components: {ChildInfoModal, asinChildChangeModal, importData, priceChangeModal, evaluationRecord},
    data() {
        return {
            showUpdatePriceBtn: false,
            query: {
                id: '',
                lowest_price_priority_order: 1,
                is_main: '',
                page: 1,
                limit: 10,
                asin: '',
            },
            loadingIndex: 0,
            starArr: ['total', 1, 2, 3, 4, 5],
            options: [{
                value: 1,
                label: '最低价优先'
            }, {
                value: 0,
                label: '非最低价优先'
            }],
            isMainArr: [{
                value: '',
                label: '全部'
            }, {
                value: 1,
                label: '主Asin'
            }, {
                value: 0,
                label: '非主Asin'
            }],
            childInfo: {},
            list: [],
            multipleSelection: [],
            disabled: false,
            loading: false,
            total: 0,
            ctrl: {
                asinChangeModal: false,
                childInfoVisible: false,
                priceChangModal: false,
                uploadFileListVisible: false,
            },
            editInfo: {},

        }
    },
    mounted() {
        checkPlug(() => this.showUpdatePriceBtn = true, () => {})
    },
    methods: {
        // 关闭弹窗
        goBackList() {
            this.query = {
                id: '',
                lowest_price_priority_order: 1,
                is_main: '',
                page: 1,
                limit: 10,
                asin: '',
            }
            this.list = []
            this.$emit('goBackList')
        },
        changeIsMain(data) {
            MessageBox.confirm(`是否${data.is_main == 1 ? '取消' : '确认'}设为主Asin`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                api.track_asin_sub_update_is_main({
                    id: data.id,
                    is_main: data.is_main == 1 ? 0 : 1,
                }).then(res => {
                    if (res.code === 0) {
                        this.$message({type: 'success', message: '更新成功'})
                        this.getList()
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).catch(res => {
                    this.$message({type: 'error', message: res.message})
                })
            }).catch(() => {
            })
        },
        updatePriceResponse() {
            this.$set(this.list[this.loadingIndex], 'loading', false)

            let responseData = JSON.parse(this.$refs.update_price_response.innerHTML)
            if (responseData.code == 0) {
                console.log('responseData', responseData)
                if ((responseData.data.local_price || '').trim() == '') {
                    this.$message.error('当前产品读不到价格')
                    this.$set(this.list[this.loadingIndex], 'loading', false)
                    return
                }
                // 处理价格
                if (responseData.data.list_price !== '') {
                    responseData.data.list_price = (responseData.data.list_price || '').replaceAll('US', '').replaceAll('$', '')
                }
                if (responseData.data.local_price !== '') {
                    responseData.data.local_price = (responseData.data.local_price || '').replaceAll('US', '').replaceAll('$', '')
                }
                console.log('response', responseData.data)

                api.callback_track_task_update_sub_asin_price_message(responseData.data).then(res => {
                    if (res.code === 0) {
                        this.$message.info('更新成功')
                        this.getList()
                    } else {
                        this.$message.warning(res.message)
                    }
                }).catch(res => {
                    this.$message.warning(res.message)
                }).finally(() => {
                    this.$set(this.list[this.loadingIndex], 'loading', false)
                })
            } else {
                this.$set(this.list[this.loadingIndex], 'loading', false)
                this.$message.error(responseData.message)
            }
        },
        pluginUpdatePrice(data, subIndex) {
            this.loadingIndex = subIndex
            this.$set(this.list[subIndex], 'loading', true)
            const div = document.getElementById('div_updatePrice')
            const obj = {website: 'www.amazon.com', asin: data.asin, id: data.id}
            div.innerText = JSON.stringify(obj)
            div.click()
        },
        //点击展开
        clickRowHandle(row, column) {
            if (['标题', '五点描述', '排名'].includes(column.label)) {
                this.childInfo.title = column.label
                this.childInfo.info = row.title
                if(column.label == '五点描述') {
                    let str = ''
                    if(Array.isArray(row.five_point)) {
                        row.five_point.map(item=>{
                            str += "  " + item + '\n'
                        })
                    }
                    this.childInfo.info = str
                } else if(column.label == '排名') {
                    this.childInfo.info = row.rank
                }
                this.ctrl.childInfoVisible = true
            }
        },
        seeChange(data) {
            this.editInfo = data
            this.ctrl.asinChangeModal = true
        },
        priceChange(data) {
            this.editInfo = data
            this.ctrl.priceChangModal = true
        },
        evaluate(data) {
            this.editInfo = data
            this.ctrl.uploadFileListVisible = true
        },
        downFile(data) {
            api.track_asin_sub_export({
                id: data.id,
            }).then(res => {
                if (res.code === 0) {
                    if (!res.data) {
                        return this.$message({
                            type: 'error',
                            message: '无法下载！'
                        })
                    }
                    downloadFileUrl(res.data, data.shop_name)
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(res => {
                this.$message({
                    type: 'error',
                    message: res.message
                })
            })
        },
        //跳转到亚马逊产品页面
        edirectToAsin(data) {
            // let url =
            //     link_us(data.state) +
            //     'dp/' +
            //     data.url_asin_href +
            //     '?th=1&psc=1'
            window.open(data.href_link, '_blank')
        },
        closeCllback(isshow) {
            this.ctrl.asinChangeModal = false
            this.ctrl.priceChangModal = false
            this.ctrl.childInfoVisible = false
            this.ctrl.uploadFileListVisible = false
            this.$refs.importDataModal.visible = false
            isshow == true && this.getList()
        },
        import_file() {
            this.$refs.importDataModal.functionStr = 'root_word_import'
            this.$refs.importDataModal.fileTxt = '上传词根数据模板.xlsx'
            this.$refs.importDataModal.tipTxt = '上传词根数据模板'
            this.$refs.importDataModal.title = '导入词根数据'
            this.$refs.importDataModal.asin = this.query.asin
            this.$refs.importDataModal.visible = true
        },
        getList(data) {
            this.query.id = data && data.id || this.query.id
            // this.query.asin = data && data.asin || this.query.asin
            this.loading = true
            const tempQuery = JSON.parse(JSON.stringify(this.query))
            if (tempQuery.is_main === '') {
                delete tempQuery.is_main
            }
            api.track_asin_sub_index(tempQuery).then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.list = (res.data.list || []).map(item => {
                        item.loading = false
                        // item.five_point = [111,222,333]
                        return item
                    })
                    this.total = res.data.total
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            })
                .catch(() => {
                    this.loading = false
                })
        },
        onDelete() {
            if (this.multipleSelection.length == 0) {
                return this.$message({
                    type: 'error',
                    message: '请勾选需要删除的词根！'
                })
            }
            this.$confirm(
                `确定要删除 ${this.query.asin} 下的 ${
                    this.multipleSelection.length
                } 个词根吗？`,
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).then(() => {
                this.loading = true
                api.seed_word_root_word_delete({
                    ids: this.multipleSelection,
                    all_deleted: 0,
                    asin: this.query.asin,
                    state: this.query.state
                }).then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        })
                        this.getList()
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                })
                    .catch(() => {
                        this.loading = false
                    })
            })
                .catch(() => {
                })
        },
        onDeleteAll() {
            this.$confirm(`确定要删除全部词根吗？`, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.loading = true
                    api.seed_word_root_word_delete({
                        ids: this.multipleSelection,
                        all_deleted: 1,
                        asin: this.query.asin,
                        state: this.query.state
                    }).then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.$message({
                                message: '全部删除成功',
                                type: 'success'
                            })
                            this.getList()
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                        .catch(() => {
                            this.loading = false
                        })
                })
                .catch(() => {
                })
        },
        //多选框
        handleSelectionChange(val) {
            let arr = []
            val.map(v => {
                arr.push(v.id)
            })
            this.multipleSelection = arr
        },
        download_file() {
            api.seed_word_root_word_export({
                asin: this.query.asin,
                state: this.query.state
            }).then((res) => {
                if (res.success) {
                    downloadFileUrl(res.data)
                }
            })
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
    }
}
</script>

<style type="text/scss" lang="scss" scoped>

.ceil-span {
    margin-right: 5px;
    width: 70px;
    height: 18px;
    float: left;
    position: relative;
}

.ceil-span-title {
    width: 50px;
    text-align: right;
    float: left;

}

.ceil-span-change {
    margin-right: 5px;
    text-align: left;
    width: 50px;
    height: 18px;
    float: left;
    position: absolute;

}

.fixedHeight {
    height: 77px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
}

.fivePointItem {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    list-style: disc;
    list-style-position: inside !important;
}


// .ceil-color {
//   color: #ff0000;
// }
.ceil-color_green {
    color: #00e640;
}

.ceil-color_red {
    color: #ff0000;
}

.filter-block {
    background-color: #a9c7ff;
    padding: 6px 6px 6px 10px;
    font-size: 18px;
    color: #333;
    margin: 0;
    display: flex;
    align-items: center;
}

/deep/ .warningred {
    background: rgb(243, 107, 107) !important;
}

/deep/ .el-form-item {
    margin-bottom: 0 !important;
}
</style>
